import { AgResourceLanguage } from '../types';

export const orderList: AgResourceLanguage['orderList'] = {
  filterOrders: {
    filterTitle: 'Bestellungen anzeigen für:',
    filterOptionTitle: 'alle Abonnements'
  },
  emptyPastOrders: {
    title: `Du hast noch nichts bestellt`,
    description: 'Shoppe und besuche diese Seite später erneut.',
    buttonName: 'Hol dir dein AG1'
  },
  emptyUpcomingOrders: {
    title: 'Du hast keine anstehenden Bestellungen',
    buttonName: 'Hol dir dein AG1'
  },
  upcomingOrders: {
    title: 'Anstehende Lieferungen',
    card: {
      orderDateLabel: 'Bestelldatum',
      subscriptionNameLabel: 'Abonnement',
      subscriptionStatusLabel: 'Status',
      unpaidStatus: 'Unbezahlt',
      totalAmountLabel: 'Gesamt',
      shipButton: 'Jetzt versenden',
      editDetailsButton: 'Details bearbeiten',
      skipShipmentButton: 'Diese Lieferung überspringen'
    }
  },
  pastOrders: {
    title: 'Lieferungen',
    table: {
      idPreSymbol: '#',
      orderNumberColumn: 'Bestellnummer',
      dateColumn: 'Datum',
      subscriptionNameColumn: 'Abonnement',
      statusColumn: 'Status',
      totalColumn: 'Gesamt',
      trackButton: 'Bestellung nachverfolgen',
      oneTimeLabel: 'Einmalig'
    },
    card: {
      idPreSymbol: '#',
      orderLabel: 'Bestellung',
      dateLabel: 'Datum:',
      subscriptionLabel: 'Abonnement',
      statusLabel: 'Status',
      totalLabel: 'Gesamt',
      trackButtonMobile: 'Bestellung nachverfolgen',
      trackButtonTablet: 'Bestellung nachverfolgen',
      viewDetailsButton: 'Details anzeigen'
    }
  }
};
